import MESSAGES from 'constants/messages';
import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';

export default ({ name }) => {
  const errors = {};

  if (!name || stringIsInvalid(name)) {
    errors.name = MESSAGES.DICTIONARIES.NAME.REGEX;
  }

  if (stringMaxLengthIsInvalid(name)) {
    errors.name = MESSAGES.DICTIONARIES.NAME.MAX_LENGTH;
  }

  return errors;
};
